import { Avatar } from '@mantine/core';
import { IconUsersGroup } from '@tabler/icons-react';

import { useResolvedImageUrl } from '@/hooks/useResolvedImageUrl';

export function GroupAvatar({
  imageUrl,
  groupId,
  size = 120,
}: {
  imageUrl?: string;
  groupId?: string;
  size?: number;
}): JSX.Element {
  const resolved = useResolvedImageUrl(imageUrl);
  const fallback =
    groupId && !imageUrl
      ? `https://picsum.photos/seed/${encodeURIComponent(groupId)}/256/256`
      : undefined;

  return (
    <Avatar
      src={resolved ?? fallback}
      alt=""
      radius="md"
      color="violet"
      style={{ flexShrink: 0, width: size, height: size, minWidth: size, minHeight: size }}
    >
      <IconUsersGroup size={Math.round(size * 0.33)} />
    </Avatar>
  );
}
